export const projectData =[
          {
                    id: 1,
                    linkUrl: 'https://driving-school-2090b.firebaseapp.com',
                    imgUrl: 'https://i.ibb.co/LPjnn6g/Capture.png',
                    name: 'Driving Car Institute',
          },
          {
                    id: 2,
                    linkUrl: 'https://ema-john-simple-project-e9fa7.web.app/',
                    imgUrl: 'https://i.ibb.co/RPckj1S/ema-john.png',
                    name: 'E-commerce Website',
          },
          {
                    id: 3,
                    linkUrl: 'https://ashrafulislampro.github.io/JavaScript-Calculator-Practice/',
                    imgUrl: 'https://i.ibb.co/BwSPmTx/calculator.png',
                    name: 'JavaScrip Calculator',
          },
          {
                    id: 4,
                    linkUrl: 'https://full-stack-assignment-10.web.app/',
                    imgUrl: 'https://i.ibb.co/r78BkWs/freshvally.png',
                    name: 'Fresh Valley',
          },
          {
                    id: 5,
                    linkUrl: 'https://ashrafulislampro.github.io/Hard-Rock-Music/',
                    imgUrl: 'https://i.ibb.co/rw7tgqS/hardRock.png',
                    name: 'Hard Rock Music',
          },
          {
                    id: 6,
                    linkUrl: 'https://ashrafulislampro.github.io/Weather-App-Project/',
                    imgUrl: 'https://i.ibb.co/r37Pmq1/weatherapp.png',
                    name: 'Weather App-Project',
          },
          {
                    id: 7,
                    linkUrl: 'https://react-auth-assignments.web.app/',
                    imgUrl: 'https://i.ibb.co/XsP7tPF/travel.png',
                    name: 'Easy Rider',
          },
          {
                    id: 8,
                    linkUrl: 'https://ashrafulislampro.github.io/Shopping-Cart-Project/',
                    imgUrl: 'https://i.ibb.co/XCYdCZT/shoppingcard.png',
                    name: 'Shopping Card',
          },
          {
                    id: 9,
                    linkUrl: 'https://ashrafulislampro.github.io/Pioneer-Bank-Project/',
                    imgUrl: 'https://i.ibb.co/N2ybZrB/pionear-bank.png',
                    name: 'Pioneer Bank',
          },
          {
                    id: 10,
                    linkUrl: 'https://ashrafulislampro.github.io/Pin-Matcher-Project/',
                    imgUrl: 'https://i.ibb.co/wB1VFzJ/pinmatcher.png',
                    name: 'Pin Matcher',
          },
          {
                    id: 11,
                    linkUrl: 'https://ashrafulislampro.github.io/Issue-Tracker-Practice-Problem/',
                    imgUrl: 'https://i.ibb.co/PxWswCG/issuetracker.png',
                    name: 'Issue Tracker',
          }
         

]